import { createSelector } from '@ngrx/store';
import { selectResultsState } from '../results.selectors';
import {
  RealEstateObject,
  ResultsState,
  SimilarResultsState,
} from '@immosky/types';
import { selectIsOnLastResultPage } from '../search-results/search-results.selectors';
import { selectIsAnyFilterActive } from '@immosky/object-search-filter';
import { selectIsLoadingSearchResults } from '@immosky/object-search-layout';

export const selectSimilarResultsState = createSelector(
  selectResultsState,
  (state: ResultsState) => state.similarResults
);

export const selectSimilarResults = createSelector(
  selectSimilarResultsState,
  (state: SimilarResultsState) => state.results
);

export const selectSimilarResultsCount = createSelector(
  selectSimilarResults,
  (results: RealEstateObject[]) => results.length
);

export const selectShowSimilarResults = createSelector(
  selectResultsState,
  selectIsOnLastResultPage,
  selectIsAnyFilterActive,
  selectIsLoadingSearchResults,
  (
    resultsState: ResultsState,
    isOnLastResultPage: boolean,
    isAnyFilterActive: boolean,
    isLoading: boolean
  ) => {
    const shouldShowSimilarObjects = isOnLastResultPage && isAnyFilterActive;
    const hasNoResults =
      resultsState.searchResults.realEstateObjects.length <= 0;

    return !isLoading && (shouldShowSimilarObjects || hasNoResults);
  }
);
